import { ButtonColors } from 'types';
import { useAppDispatch } from 'store';
import { Icon } from 'components/icon';
import { Button } from 'components/button';
import { markAllAsReadNotifications } from 'store/slices/notifications';

import * as Styles from './styles';
import { NotificationHeaderProps } from './types';

export const NotificationHeader = ({
  isDialog,
  unreadCount,
}: NotificationHeaderProps) => {
  const dispatch = useAppDispatch();

  if (!unreadCount) {
    return null;
  }

  return (
    <Styles.Header isDialog={isDialog}>
      <p>Unread Notifications: {unreadCount}</p>

      <Button
        transparent={isDialog}
        disabled={!unreadCount}
        tooltip="Mark all as read"
        icon={<Icon.CheckCircle />}
        colorType={ButtonColors.LightBlue}
        padding={isDialog ? '0' : undefined}
        onClick={() => dispatch(markAllAsReadNotifications())}
      />
    </Styles.Header>
  );
};
